<ng-container>
  <div *ngIf="form!.controls![question?.quesId+'_id_'+controlIndex]?.invalid && 
  (form!.controls![question?.quesId+'_id_'+controlIndex]?.dirty || 
  form!.controls![question?.quesId+'_id_'+controlIndex]?.touched)" class="errMsg" [ngClass]="isArabic ? 'rightAlign' : ''">
    <span *ngIf="form!.controls[question?.quesId+'_id_'+controlIndex]!.errors!['required']">
      <span *ngIf="!isArabic">This field is required!!</span>
      <span *ngIf="isArabic">هذا الحقل مطلوب</span>
    </span>
    <span *ngIf="!form!.controls[question?.quesId+'_id_'+controlIndex]!.errors!['required'] && errorType" class="errMsg">
      {{errorMsg}}
    </span>
  </div>   
</ng-container>

